/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */
import { VideoEncoding, VideoPreset } from 'livekit-client';

/**
 * Live options loader for modal selector (before call start)
 */
export const ScreenSharePresetsCalls = {
  // h360fps3: new VideoPreset(640, 360, 200_000, 3, 'medium'),
  // h360fps15: new VideoPreset(640, 360, 400_000, 15, 'medium'),
  // h720fps5: new VideoPreset(1280, 720, 800_000, 5, 'medium'),
  h720fps15: new VideoPreset(1280, 720, 1_500_000, 15, 'medium'),
  h720fps30: new VideoPreset(1280, 720, 4_000_000, 30, 'medium'),
  h720fps60: new VideoPreset(1280, 720, 4_500_000, 60, 'high'),
  h1080fps15: new VideoPreset(1920, 1080, 2_500_000, 15, 'medium'),
  h1080fps30: new VideoPreset(1920, 1080, 8_000_000, 30, 'medium'),
  h1080fps60: new VideoPreset(1920, 1080, 10_000_000, 60, 'high'),
  // original resolution, without resizing
  // original: new VideoPreset(0, 0, 7_000_000, 30, 'medium'),
} as const;

/**
 * Live options before call start to actually use
 */
export const ScreenShareVideoEncodings = {
  h720p15: {
    maxBitrate: 1_500_000,
    maxFramerate: 15,
    priority: 'medium',
  } as VideoEncoding,
  h720p30: {
    maxBitrate: 4_000_000,
    maxFramerate: 30,
    priority: 'medium',
  } as VideoEncoding,
  h720p60: {
    maxBitrate: 4_500_000,
    maxFramerate: 60,
    priority: 'high',
  } as VideoEncoding,
  h1080p15: {
    maxBitrate: 2_500_000,
    maxFramerate: 15,
    priority: 'medium',
  } as VideoEncoding,
  h1080p30: {
    maxBitrate: 8_000_000,
    maxFramerate: 30,
    priority: 'medium',
  } as VideoEncoding,
  h1080f60: {
    maxBitrate: 10_000_000,
    maxFramerate: 60,
    priority: 'high',
  } as VideoEncoding,
} as const;
